import React, { useState } from 'react';
import Sidebar from './Sidebar'; // تغییر مسیر import
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar for mobile */}
      <div className={`fixed inset-y-0 right-0 z-40 w-64 transition-transform duration-300 ease-in-out transform ${sidebarOpen ? 'translate-x-0' : 'translate-x-full'} md:hidden`}>
        <div className="h-full bg-blue-800 shadow-xl">
          <div className="flex justify-between items-center p-4 bg-blue-900">
            <button
              type="button"
              className="text-white hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
              onClick={toggleSidebar}
            >
              <span className="sr-only">بستن منو</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
            <h1 className="text-xl font-bold text-white">ادمین هوشمند</h1>
          </div>
          <Sidebar closeSidebar={() => setSidebarOpen(false)} />
        </div>
      </div>

      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75 z-30 md:hidden" onClick={toggleSidebar}></div>
      )}

      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0">
        <div className="flex flex-col w-64">
          <Sidebar />
        </div>
      </div>

      {/* Main content */}
      <div className="flex flex-col flex-1 overflow-hidden">
        <header className="bg-white shadow-sm md:hidden">
          <div className="px-4 py-4 flex items-center justify-between">
            <button
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
              onClick={toggleSidebar}
            >
              <span className="sr-only">باز کردن منو</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
            <h1 className="text-lg font-semibold text-gray-900">ادمین هوشمند</h1>
          </div>
        </header>
        <main className="flex-1 relative overflow-y-auto focus:outline-none">
          <div className="py-4"> {/* کاهش padding */}
            <div className="mx-auto px-2 sm:px-3 md:px-4"> {/* کاهش padding */}
              {children}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
